export enum LiveType {
  Public = 1,
  Private = 2,
  Organization = 3,
}
